import { CartOrders } from '@/features/cart-page/CartOrders/ui/CartOrders'
import './ui/CartOrders.scss'
export default CartOrders
